import { Section } from '@pkdigital/pkd-custom-components';
import React from 'react';
import { TrustBox } from './trust-box';

interface TrustPilotSectionProps {
  title?: string;
}

export const TrustPilotSection: React.FC<TrustPilotSectionProps> = ({ title }) => {
  return (
    <Section className="trust-pilot">
      <div className="content container-md">
        <TrustBox />
      </div>
    </Section>
  );
};
